module.exports = __webpack_public_path__ + "img/search.79512e9a.png";